export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/cartoon_pattern.e267617.svg";